import { PopUpBase } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypePopUpIframe } from '../types';

/**
 * PopUpIframe
 */
export const PopUpIframe: FunctionComponent<TypePopUpIframe> = ({
  state,
  src,
  setState,
  className,
  title = '',
  desc = '',
  ...props
}: TypePopUpIframe) => {
  const clickHanlder = () => {
    setState(!state);
  };
  return (
    <PopUpBase
      title={title}
      desc={desc}
      state={state}
      funcionOnClose={clickHanlder}
      className={`bg-white ${className}`}
      type="iframe"
    >
      <iframe
        allowFullScreen={true}
        src={src}
        title="Iframe Be Casa"
        {...props}
        className={`absolute inset-0 h-full w-full border-none ${className}`}
      />
    </PopUpBase>
  );
};

PopUpIframe.displayName = 'PopUpIframe';
